<template>
	<div class="public-mask">
		<div class="public-content">
			<div class="public-title">
				<span>{{caseInfo.caseNo}}</span>
				<i class="el-icon-close" @click="closeMask"></i>
			</div>
			<div class="public-box">
				<div class="public-item">
					<div class="public-item-title">
						委托人信息
					</div>
					<div class="public-item-area" v-loading="loading">
						<div class="public-unit">
							<div class="key">
								委托机构：
							</div>
							<div class="value">
								{{caseInfo.entrustmentOrganName}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								联系人：
							</div>
							<div class="value">
								{{caseInfo.contacts}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								联系方式：
							</div>
							<div class="value">
								{{caseInfo.phone}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								委托人：
							</div>
							<div class="value">
								{{caseInfo.entrustmentName}}
							</div>
						</div>
						<div class="public-unit-mid">
							<div class="key">
								地址：
							</div>
							<div class="value">
								{{caseInfo.address}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								被鉴定人：
							</div>
							<div class="value">
								{{caseInfo.identifiedName}}
							</div>
						</div>
						<div class="public-unit-mid">
							<div class="key">
								证件号码：
							</div>
							<div class="value">
								{{caseInfo.identifiedCertificateNo}}
							</div>
						</div>
					</div>
				</div>
				<div class="public-item">
					<div class="public-item-title">
						鉴定意见
					</div>
					<div class="public-item-area" v-loading="loading">
						<div class="public-textarea">
							<span>{{caseInfo.appraisalOpinion}}</span>
						</div>
					</div>
				</div>
				<div class="public-upload">
					<div class="public-upload-key">
						鉴定意见书：
					</div>
					<div class="public-upload-area" v-loading="loading">
						<i class="el-icon-notebook-2"></i>
						<a :href="caseInfo.filePath" target="_blank">
							{{caseInfo.documentName}}
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'opinion',
		props: ['infoId', 'userType'],
		data() {
			return {
				caseInfo: {

				},
				loading:true
			};
		},
		methods: {
			closeMask() {
				this.$emit('closeOpinion')
			},
			getCaseInfo() {
				this.$api.findCaseInformationById({
					'id': this.$props.infoId
				}, res => {
					this.caseInfo = res.data
					this.loading = false
				})
			},
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.getCaseInfo()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	@import url("../global.less");
</style>
